// extracted by mini-css-extract-plugin
module.exports = {"loader":"SearchModal_loader__ZprLj","search":"SearchModal_search__a-hGt"};